import React from 'react';
import TransitionComponent from '../../components/TransitionComponent';

const TransitionSection = ({
    allActions,
    menu_name,
    processId,
    statusId,
    statusArray,
    branches,
    groups,
    selectedDocId,
    userPermission,
    showBranch,
    showGroup,
    showInbox,
    closeTransition,
    isLocked,
    menuGroup,
    menuBranch,
    menuInbox,
    callingFrom,
}) => (
    <div className='wrap_transition p-4'>
        <div className='d-flex transition_part transition_title_mobile align-items-stretch justify-content-between mb-5 pb-2'>
            <div className='transition_fun'>
                <span>
                    <i
                        className={
                            allActions.hasOwnProperty('transition') &&
                            allActions.transition.icon !== null
                                ? allActions.transition.icon
                                : 'fa-regular fa-arrow-right-arrow-left'
                        }
                        title='Transition'
                        style={{
                            color:
                                allActions.hasOwnProperty('transition') &&
                                allActions.transition.color !== null
                                    ? allActions.transition.color
                                    : '',
                        }}
                    />
                    Transition
                </span>
            </div>
        </div>

        <TransitionComponent
            content='normal'
            menu_name={menu_name}
            processId={processId}
            statusId={statusId}
            statusArray={statusArray}
            branches={branches}
            groups={groups}
            selectedDocId={selectedDocId}
            editTransition={false}
            branchActionId={userPermission?.branchActionId}
            groupActionId={userPermission?.groupActionId}
            showBranch={showBranch}
            showGroup={showGroup}
            showInbox={showInbox}
            closeTransition={(param) => {
                closeTransition.call(this);
            }}
            isLocked={isLocked}
            menuGroup={menuGroup}
            menuBranch={menuBranch}
            menuInbox={menuInbox}
            calingFrom={callingFrom}
        />
    </div>
);

export default TransitionSection;
